import api from './APIConstructor';

export default api({
    type: 'quest',
    sets: ['pages', 'questions']
});
